import ROUTE_CONSTANTS from '@/src/constants/route-constants.js'
import { objectDeepCopy } from '@/src/utils/generalUtil'
export default {
  SET_FEATURE_NAME(state, payload) {
    const updatedList = objectDeepCopy(ROUTE_CONSTANTS)
    const updateDisplayName = (obj, payloadItem) => {
      for (const key in obj) {
        const value = obj[key]
        if (typeof value === 'object' && value !== null) {
          updateDisplayName(value, payloadItem)
        }
        if (obj.NAME === payloadItem.original_name) {
          obj.DISPLAY_NAME = payloadItem.custom_name
        }
      }
    }
    payload.forEach((item) => {
      updateDisplayName(updatedList, item)
    })
    state.routerList = updatedList
  },
}
